export const FETCH_BRAND_DETAILS_BEGIN = 'FETCH_BRAND_DETAILS_BEGIN';
export const FETCH_BRAND_DETAILS_SUCCESS = 'FETCH_BRAND_DETAILS_SUCCESS';
export const FETCH_BRAND_DETAILS_FAILURE = 'FETCH_BRAND_DETAILS_FAILURE';